import { useQuery } from '@tanstack/react-query';
import type { ApprovalInboxCountResponse, ApprovalInboxPaymentScope } from '@metycle/shared';
import { apiRequest } from '@/lib/api-client';
import { approvalsInboxKeys } from './keys';

export function useApprovalsInboxCount(paymentScope: ApprovalInboxPaymentScope = 'all') {
  return useQuery({
    queryKey: approvalsInboxKeys.count(paymentScope),
    queryFn: ({ signal }) => {
      const suffix = paymentScope === 'all' ? '' : `?payment_scope=${paymentScope}`;
      return apiRequest<ApprovalInboxCountResponse>(`/approvals/inbox/count${suffix}`, { signal });
    },
    refetchOnWindowFocus: true,
  });
}
